<ngx-loading [show]="loading" [config]="{fullScreenBackdrop : true}"></ngx-loading>
<div class="container" style="width:100%">
  <mat-tab-group>
    <mat-tab label="Profile Info" *ngIf="sprovider">
      <div class="card" style="margin:1%;border-color:#cb983f,2px,solid">
            <div class="row">
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                 <h6><p style="font-style:open sans; color:#9b7544">Name:</p></h6>
                    <input type="taxt" [(ngModel)] = "sprovider[0].name">
              </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <h6><p style="font-style:open sans; color:#9b7544">Mobile:</p></h6>
                        <input type="taxt" [(ngModel)] = "sprovider[0].mobile">
               </div>
              <div class="col-sm-12 col-md-12 col-lg-4 col-xl-4">
                  <h6><p style="font-style:open sans; color:#9b7544">Email:</p></h6>
                        <input type="taxt" [(ngModel)] = "sprovider[0].email">
                </div>
            </div>
            <div class="row">
              <div class="col-12">
                  <h6><p style="font-style:open sans; color:#9b7544">Address:</p></h6>
                  <p style="font-style:open sans;  overflow-wrap:break-word ">
                    <textarea rows="4" class="col-10" [(ngModel)] = "sprovider[0].address"></textarea></p>
              </div>
            </div>
            <div class="row">
                <div class="col-12">
                      <h6><p style="font-style:open sans; color:#9b7544">About:</p></h6>
                      <p style="font-style:open sans;  overflow-wrap:break-word ">
                      <textarea rows="4" class="col-10" [(ngModel)] = "sprovider[0].about"></textarea>
                    </p>
                </div>
              </div>
              <div class="row">
                  <div class="col-12">
                      <h6><p style="font-style:open sans; color:#9b7544">Qualification:</p></h6>
                      <p style="font-style:open sans;  overflow-wrap:break-word ">
                      <textarea rows="4" class="col-10" [(ngModel)] = "sprovider[0].qualification"></textarea>
                  </p>
                    </div>
                </div>
                <div class="row">
                    <div class="col-12">
                        <h6><p style="font-style:open sans; color:#9b7544">Experience:</p></h6>
                        <p style="font-style:open sans;  overflow-wrap:break-word ">
                          <textarea rows="4" class="col-10 " [(ngModel)] = "sprovider[0].experience"></textarea>
                   </p> </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                        <h6><p style="font-style:open sans; color:#9b7544">Experience Detail:</p></h6>
                        <p style="font-style:open sans;  overflow-wrap:break-word ">
                          <textarea rows="4" class="col-10" [(ngModel)] = "sprovider[0].expdetails"></textarea>
                   </p> </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                        <h6><p style="font-style:open sans; color:#9b7544">Education:</p></h6>
                        <p style="font-style:open sans;  overflow-wrap:break-word ">
                          <textarea rows="4" class="col-10"  [(ngModel)] = "sprovider[0].education"></textarea>
                   </p> </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                        <h6><p style="font-style:open sans; color:#9b7544">Awards:</p></h6>
                        <p style="font-style:open sans;  overflow-wrap:break-word ">
                          <textarea rows="4" class="col-10"  [(ngModel)] = "sprovider[0].awards"></textarea>
                   </p> </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                        <h6><p style="font-style:open sans; color:#9b7544">Membership:</p></h6>
                        <p style="font-style:open sans;  overflow-wrap:break-word ">
                          <textarea rows="4" class="col-10"  [(ngModel)] = "sprovider[0].membership"></textarea>
                   </p> </div>
                  </div>
                  <div class="row">
                    <div class="col-12">
                        <h6><p style="font-style:open sans; color:#9b7544">Registration No:</p></h6>
                        <p style="font-style:open sans;  overflow-wrap:break-word ">
                          <textarea class="col-10" [(ngModel)] = "sprovider[0].registration"></textarea>
                   </p> </div>
                  </div>
                  <div class="row">
                    <div class="col-sm-12 text-center">
                      <button class="btn btn-success" (click)="saveData()">Save Data</button>
                    </div>
                  </div>
                </div>
    </mat-tab>
    <mat-tab label="Specialisation" *ngIf="specialisation && specialist">




          <div class="row" style="margin-top:4%; margin-left:1%; border-bottom:1px solid #9b7544"
          *ngIf="specialist && specialist.length>0">
              <h5><p style="overflow-wrap:break-word; font-style: open-sans">
               Your Specialisation
              </p></h5>
            </div>
            <div class="row" style="margin-top:4%; margin-left:1%; border-bottom:1px solid #9b7544"
            *ngIf="specialist && specialist.length == 0">
                <h5><p style="overflow-wrap:break-word; font-style: open-sans">
                 No Specialisation Add with your profile
                </p></h5>
              </div>
          <div class="row" *ngIf="specialist && specialist.length>0" >
              <div class="col-12 text-center">
                <table id="pctab" class="table table-bordered" class="table table-bordered"
                style="border-color:#cb983f,2px,solid" class="table table-bordered" >
                <tr class="card-header">
                    <th>index</th>
                    <th>Specialisation name</th>
                    <th>Manage</th>
                 </tr>
                 <tr *ngFor="let s of specialist ; let i = index">
                    <td>{{i + 1}}</td>
                <td >
                  <div *ngFor="let a of specialisation">
                  <div *ngIf="a.id == s.specialisation_id">
                  {{a.name}}
                  </div>
                  </div>
                </td>
                 <td>
               <div class="tg-btnaction">
                  <a class="tg-btndelete" style="color:#fff,!important"
                 (click)="deleteSpecialisation(s.id)" ><i class="fa fa-minus"></i></a>
             </div>
         </td>
      </tr>
               </table>
              </div>
            </div>


            <div class="row" style="margin:1%" *ngIf="special.length>0">
                <h5><p style="overflow-wrap:break-word; font-style: open-sans">
               You Can Add this specialisation with your profile
                </p></h5>
              </div>
              <div class="row" *ngIf="special.length>0">
                <div class="col-12 text-center">
                  <table id="pctab" class="table table-bordered" class="table table-bordered"
                  style="border-color:#cb983f,2px,solid" class="table table-bordered">
                  <tr class="card-header">
                      <th>Specialisation name</th>
                      <th>Manage</th>
                   </tr>
                   <tr *ngFor="let s of special | paginate: { itemsPerPage: 5, currentPage: p };">
                  <td >{{s.name}}</td>
                   <td class="text-right">
                 <div class="tg-btnaction">
                   <button class="btn btn-success " (click)="addSpecialisation(s.id)">Add  Specialisation</button>
               </div>
            </td>
            </tr>
                 </table>
                </div>
              </div>



    </mat-tab>
    <mat-tab label="Services" *ngIf="allservices && servicemenu">


        <div class="row" style="margin-top:4%; margin-left:1%; border-bottom:1px solid #9b7544"
        *ngIf="servicemenu.length > 0">
            <h5><p style="overflow-wrap:break-word; font-style: open-sans">
             Your Listed Services
            </p></h5>
          </div>
          <div class="row" style="margin-top:4%; margin-left:1%; border-bottom:1px solid #9b7544"
          *ngIf="servicemenu.length == 0">
              <h5><p style="overflow-wrap:break-word; font-style: open-sans">
               NO Services Added with your profile . Please add services whatever you want to provide
              </p></h5>
            </div>
        <div class="row" *ngIf="servicemenu.length > 0">
            <div class="col-12 text-center">
              <table id="pctab" class="table table-bordered" class="table table-bordered"
              style="border-color:#cb983f,2px,solid" class="table table-bordered">
              <tr class="card-header">
                  <th>index</th>
                  <th>sevice name</th>
                  <th>Fees</th>
                  <th>Manage</th>
               </tr>
               <tr *ngFor="let s of servicemenu ; let i = index">
                  <td>{{i + 1}}</td>
              <td >
                <div *ngFor="let a of allservices">
                <div *ngIf="a.id == s.service_id">
                {{a.name}}
                </div>
                </div>
              </td>
              <td >{{s.fees}}</td>
               <td>
             <div class="tg-btnaction">
                <a class="tg-btnview" (click)="serviceEdit(s.id, s.service_id, s.fees)"><i class="fa fa-check"></i></a>
                <a class="tg-btndelete" style="color:#fff,!important"
                (click)=" deleteServicemenu(s.id)"><i class="fa fa-minus"></i></a>
           </div>
       </td>
    </tr>
            </table>
            </div>
          </div>
          <div  style="margin:1%; margin-bottom:10px; border:2px solid #9b7544" *ngIf="addservicediv === 1">
            <div class="col-12">
              <h5><p style="overflow-wrap:break-word; font-style: open-sans">
              <strong>Add Service</strong>
              </p></h5>
            </div>
            <div class="row">
                <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2">
                 <h5>{{addsname}}</h5>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-6 col-xl-6">
                  <div class="form-group">
                  <label>Fees</label>
                  <input type="number" [(ngModel)]="addfees">
                  </div>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2">
                  <button class="btn btn-success" *ngIf="addfees" (click)="conFirmAddService()">Confirm</button>
                </div>
                <div class="col-sm-12 col-md-6 col-lg-2 col-xl-2">
                    <button class="btn btn-success2" (click)="cancelDiv()">Cancel</button>
                </div>
            </div>
  
          </div>

          <div class="row" style="margin:1%" *ngIf="services.length>0">
            <h5><p style="overflow-wrap:break-word; font-style: open-sans">
           You Can Add this services with your profile
            </p></h5>
          </div>
          <div class="row" *ngIf="services.length>0">
            <div class="col-12 text-center">
              <table id="pctab" class="table table-bordered" class="table table-bordered"
              style="border-color:#cb983f,2px,solid" class="table table-bordered">
              <tr class="card-header">
                  <th>sevice name</th>
                  <th>Manage</th>
               </tr>
               <tr *ngFor="let s of services | paginate: { itemsPerPage: 5, currentPage: p };">
              <td >{{s.name}}</td>
               <td class="text-right">
             <div class="tg-btnaction">
               <button class="btn btn-success " (click)="addService(s.id, s.name)">Add This Service</button>
           </div>
       </td>
    </tr>
             </table>
            </div>
          </div>

          <div class="row" *ngIf="services.length>0" >
              <div class="col-12 text-right">
                  <pagination-controls  (pageChange)="p = $event" ></pagination-controls >
              </div>
            </div>
    </mat-tab>
  </mat-tab-group>
  </div>
